import React from 'react';

const CalculatorIcon = () => (
  <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.61127 5.83328C6.61127 5.21963 7.10874 4.72217 7.72238 4.72217H13.2779C13.8916 4.72217 14.3891 5.21963 14.3891 5.83328V9.16661C14.3891 9.78026 13.8916 10.2777 13.2779 10.2777H7.72238C7.10874 10.2777 6.61127 9.78026 6.61127 9.16661V5.83328ZM8.27794 8.61106V6.38883H12.7224V8.61106H8.27794Z"
      fill="currentColor"
    />
    <path
      d="M6.61127 11.9444C6.61127 11.4842 6.98437 11.1111 7.44461 11.1111H9.11127C9.57151 11.1111 9.94461 11.4842 9.94461 11.9444C9.94461 12.4046 9.57151 12.7777 9.11127 12.7777H7.44461C6.98437 12.7777 6.61127 12.4046 6.61127 11.9444Z"
      fill="currentColor"
    />
    <path
      d="M11.8891 11.1111C11.4288 11.1111 11.0557 11.4842 11.0557 11.9444C11.0557 12.4046 11.4288 12.7777 11.8891 12.7777H13.5557C14.016 12.7777 14.3891 12.4046 14.3891 11.9444C14.3891 11.4842 14.016 11.1111 13.5557 11.1111H11.8891Z"
      fill="currentColor"
    />
    <path
      d="M6.61127 14.4444C6.61127 13.9842 6.98437 13.6111 7.44461 13.6111H9.11127C9.57151 13.6111 9.94461 13.9842 9.94461 14.4444C9.94461 14.9046 9.57151 15.2777 9.11127 15.2777H7.44461C6.98437 15.2777 6.61127 14.9046 6.61127 14.4444Z"
      fill="currentColor"
    />
    <path
      d="M11.8891 13.6111C11.4288 13.6111 11.0557 13.9842 11.0557 14.4444C11.0557 14.9046 11.4288 15.2777 11.8891 15.2777H13.5557C14.016 15.2777 14.3891 14.9046 14.3891 14.4444C14.3891 13.9842 14.016 13.6111 13.5557 13.6111H11.8891Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.88905 2.22217C5.20151 2.22217 3.8335 3.59019 3.8335 5.27772V14.7222C3.8335 16.4097 5.20151 17.7777 6.88905 17.7777H14.1113C15.7988 17.7777 17.1668 16.4097 17.1668 14.7222V5.27772C17.1668 3.59019 15.7988 2.22217 14.1113 2.22217H6.88905ZM5.50016 5.27772C5.50016 4.51066 6.12199 3.88883 6.88905 3.88883H14.1113C14.8783 3.88883 15.5002 4.51066 15.5002 5.27772V14.7222C15.5002 15.4892 14.8783 16.1111 14.1113 16.1111H6.88905C6.12199 16.1111 5.50016 15.4892 5.50016 14.7222V5.27772Z"
      fill="currentColor"
    />
  </svg>
);

export default CalculatorIcon;
